module.exports = __webpack_public_path__ + "static/media/031.75959660.png";